import React, { useEffect, useState } from 'react';
import { Link as Scroll } from 'react-scroll';
import './navbar.css';


export default function Navbar() {
  const [checked, setChecked] = useState(false);
  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  useEffect(() => {
    setChecked(true);
  }, []);

  return (
    <nav className="navbar">
      <div className="container">
        <div className="logo">
          <Scroll to='header' smooth={true}>
            {/* <Logo /> */}
          </Scroll>
        </div>
        <div className="menu-icon" onClick={handleShowNavbar}>
          <Hamburger />
        </div>
        <div className={`nav-elements  ${showNavbar && 'active'}`}>
          <ul>
            <li>
              <Scroll to='gran-dia' smooth={true} onClick={handleShowNavbar}>
                <span className='nav-span' style={{ fontSize: '1.9em', cursor: 'pointer' }}>El Gran Día</span>
              </Scroll>
            </li>
            <li>
              <Scroll to='galeria' smooth={true} onClick={handleShowNavbar}>
                <span className='nav-span' style={{ fontSize: '1.9em', cursor: 'pointer' }}>Galería</span>
              </Scroll>
            </li>
            <li>
              <Scroll to='lugar-boda' smooth={true} onClick={handleShowNavbar}>
                <span className='nav-span' style={{ fontSize: '1.9em', cursor: 'pointer' }}>La Boda</span>
              </Scroll>
            </li>
            <li>
              <Scroll to='mesa-de-regalos' smooth={true} onClick={handleShowNavbar}>
                <span className='nav-span' style={{ fontSize: '1.9em', cursor: 'pointer' }}>Mesa de regalos</span>
              </Scroll>
            </li>
            <li>
              <Scroll to='confirmar-asistencia' smooth={true} onClick={handleShowNavbar}>
                <span className='nav-span' style={{ fontSize: '1.9em', cursor: 'pointer' }}>Confirmar asistencia</span>
              </Scroll>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}


const Hamburger = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="24"
    viewBox="0 0 52 24"
  >
    <g id="Group_9" data-name="Group 9" transform="translate(-294 -47)">
      <rect
        id="Rectangle_3"
        data-name="Rectangle 3"
        width="42"
        height="4"
        rx="2"
        transform="translate(304 47)"
        fill="#e2e1e1"
      />
      <rect
        id="Rectangle_5"
        data-name="Rectangle 5"
        width="42"
        height="4"
        rx="2"
        transform="translate(304 67)"
        fill="#e2e1e1"
      />
      <rect
        id="Rectangle_4"
        data-name="Rectangle 4"
        width="52"
        height="4"
        rx="2"
        transform="translate(294 57)"
        fill="#e2e1e1"
      />
    </g>
  </svg>
);

